// extracted by mini-css-extract-plugin
export default {"about_us":"AboutUs_about_us__4GLOB","worker_img":"AboutUs_worker_img__F-NJQ"};